import * as React from 'react';
import styled from '@emotion/styled'
import { graphql } from 'gatsby';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

interface WrapperProps {
  className?: string;
}

const Wrapper: React.FunctionComponent<WrapperProps> = ({ children, className }) => (
  <StyledWrapper className={className}>{children}</StyledWrapper>
);

export default Wrapper;


export const logoFragment = graphql`
  fragment Logo on Query {
    logo: file(relativePath: { eq: "img/blog-logo.png" }) {
        childImageSharp {
          fixed {
            ...GatsbyImageSharpFixed
          }
        }
    }
  }
`

export const smallLogoFragment = graphql`
  fragment SmallLogo on Query {
    logo: file(relativePath: { eq: "img/blog-logo-small.png" }) {
        childImageSharp {
          fixed {
            ...GatsbyImageSharpFixed
          }
        }
    }
  }
`